import banner from "../../../courses/module-2/img3.png";

const modulo3_pt = {
  courseId: "cripto-blockchain",
  id: "modulo-3",
  title:
    "🧩 MÓDULO 3: Bitcoin, Ethereum, Solana, Cardano, Polygon e Stellar – As Grandes Ligas do Cripto",
  estimatedDuration: "1 hora e 30 minutos",
  format: "Leitura + atividade de verificação",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivo do módulo",
      content: [
        "Conhecer as características, diferenças e principais usos de seis blockchains líderes no mundo cripto, entendendo para que serve cada uma, como funcionam e por que é importante não confundir redes na hora de operar.",
      ],
    },
    {
      id: "por-que",
      navLabel: "Por que tantas?",
      title: "🌍 Por que existem tantas blockchains?",
      content: [
        {
          type: "paragraph",
          text: "Cada blockchain nasceu com um objetivo diferente: algumas priorizam velocidade, outras segurança, sustentabilidade, inclusão financeira ou execução de contratos inteligentes.",
        },
        {
          type: "paragraph",
          text: "Por isso, é essencial saber qual rede é mais adequada para cada caso.",
        },
      ],
    },
    {
      id: "bitcoin",
      navLabel: "Bitcoin (BTC)",
      title: "🔹 Bitcoin (BTC): o pioneiro e o “ouro digital”",
      content: [
        {
          type: "paragraph",
          text: "O que é? A primeira criptomoeda, criada em 2009 para permitir pagamentos sem bancos.",
        },
        {
          type: "paragraph",
          text: "Uso principal: Armazenar valor (como se fosse ouro digital) e enviar pagamentos simples.",
        },
        {
          type: "paragraph",
          text: "Curiosidade: É a rede mais segura, mas também a mais lenta e cara.",
        },
      ],
    },
    {
      id: "ethereum",
      navLabel: "Ethereum (ETH)",
      title: "🔹 Ethereum (ETH): a base do mundo Web3",
      content: [
        {
          type: "paragraph",
          text: "O que é? Uma blockchain que permite criar aplicativos descentralizados (dApps) e contratos inteligentes (smart contracts).",
        },
        {
          type: "paragraph",
          text: "Uso principal: Finanças descentralizadas (DeFi), NFTs, DAOs e muito mais.",
        },
        {
          type: "paragraph",
          text: "Curiosidade: Passou a usar um sistema mais ecológico em 2022 chamado Proof of Stake.",
        },
        {
          type: "table",
          headers: ["Conceito", "O que é?", "Para que serve?", "Exemplo"],
          rows: [
            [
              "DeFi",
              "Sistema financeiro sem bancos",
              "Pagar juros, emprestar, investir",
              "Uma plataforma que paga rendimento em cripto",
            ],
            [
              "NFT",
              "NFT	Item digital único",
              "Arte, música, ingressos, colecionáveis",
              "Ingresso NFT ou arte digital",
            ],
            [
              "DAO",
              "Comunidade digital governada por votos",
              "Tomar decisões e investir em grupo",
              "Fundo de investimento votado pela comunidade",
            ],
          ],
        },
      ],
    },
    {
      id: "solana",
      navLabel: "Solana (SOL)",
      title: "🔹 Solana (SOL): alta velocidade para jogos e NFTs",
      content: [
        {
          type: "paragraph",
          text: "O que é? Uma blockchain focada em velocidade e taxas muito baixas.",
        },
        {
          type: "paragraph",
          text: "Uso principal: Jogos Web3, mercados de NFTs, apps móveis.",
        },
        {
          type: "paragraph",
          text: "Curiosidade: Já enfrentou interrupções, mas ainda é uma das redes mais usadas do mundo.",
        },
      ],
    },
    {
      id: "cardano",
      navLabel: "Cardano (ADA)",
      title: "🔹 Cardano (ADA): sustentabilidade e inclusão social",
      content: [
        {
          type: "paragraph",
          text: "O que é? Uma blockchain construída com base em estudos científicos e revisão por pares.",
        },
        {
          type: "paragraph",
          text: "Uso principal: Projetos sociais, sistemas de votação, contratos inteligentes.",
        },
        {
          type: "paragraph",
          text: "Curiosidade: Trabalha com governos africanos para registrar dados educacionais.",
        },
      ],
    },
    {
      id: "polygon",
      navLabel: "Polygon (MATIC)",
      title: "🔹 Polygon (MATIC): acelerando a Ethereum",
      content: [
        {
          type: "paragraph",
          text: "O que é? Uma Layer 2, solução ligada à Ethereum para torná-la mais rápida e barata.",
        },
        {
          type: "paragraph",
          text: "Uso principal: Construção de apps, programas de fidelidade, colecionáveis digitais.",
        },
        {
          type: "paragraph",
          text: "Curiosidade: Usada por gigantes como Disney, Meta, Adidas e Reddit.",
        },
      ],
    },
    {
      id: "stellar",
      navLabel: "Stellar (XLM)",
      title:
        "🔹 Stellar (XLM): transferências internacionais simples e rápidas",
      content: [
        {
          type: "paragraph",
          text: "O que é? Uma blockchain pensada para pagamentos globais com taxas baixas.",
        },
        {
          type: "paragraph",
          text: "Uso principal: Remessas internacionais, câmbio de moedas, apoio a ONGs.",
        },
        {
          type: "paragraph",
          text: "Curiosidade: Parcerias com Visa, IBM, MoneyGram e ONU.",
        },
      ],
    },
    {
      id: "videos",
      navLabel: "Vídeos",
      title: "📺 Vídeos recomendados",
      content: [
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=bbfRK6J47Kk",
          text: "🎥 O que é Bitcoin? – Explicação para iniciantes",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=LcQeh1EW8oE",
          text: "🎥 O que é Ethereum? – Cripto em Minutos",
        },
        {
          type: "link",
          href: "https://www.youtube.com/shorts/D2mBiJqHXi8",
          text: "🎥 Solana vs Ethereum – Comparativo",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=9-V3IKbfL5I",
          text: "🎥 Introdução a Cardano",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=7BZc_a5hsp0",
          text: "🎥 Polygon explicado de forma simples",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=jAQ56ViEQIw",
          text: "🎥 O que é Stellar (XLM)? – Binance Academy",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Atividade",
      title: "📊 Atividade do módulo",
      content: [
        "Instrução:",
        "Complete a seguinte tabela comparativa entre as 6 redes estudadas. Pode fazer no Google Docs, Canva, Notion ou até no papel.",
        "Isso cria um “mapa mental” rápido para revisar sempre que precisar.",
        {
          type: "table",
          headers: [
            "Rede",
            "Para que é usada?",
            "Velocidade aprox. (TPS)",
            "Segurança",
            "Comunidade / Projetos de destaque",
          ],
          rows: [
            ["Bitcoin", "", "", "", ""],
            ["Ethereum", "", "", "", ""],
            ["Solana", "", "", "", ""],
            ["Cardano", "", "", "", ""],
            ["Polygon", "", "", "", ""],
            ["Stellar", "", "", "", ""],
          ],
        },
      ],
    },
    {
      id: "nota",
      navLabel: "Nota importante",
      title:
        "⚠️ NOTA IMPORTANTE – Não confunda a rede, o token, a abreviatura e a criptomoeda",
      content: [
        {
          type: "paragraph",
          text: "No mundo cripto, esses termos parecem similares, mas significam coisas bem diferentes.",
        },
        {
          type: "paragraph",
          text: "🧩 Diferenças essenciais",
        },
        {
          type: "table",
          headers: ["Termo", "O que é?", "Exemplo"],
          rows: [
            ["Criptomoeda", "O ativo digital em si", "BTC, ETH, USDC"],
            [
              "Token",
              "Moeda criada sobre outra blockchain",
              "USDC existe em várias redes",
            ],
            [
              "Rede (blockchain)",
              "A infraestrutura que armazena e valida transações",
              "Ethereum, Solana, Stellar",
            ],
            [
              "Abreviatura",
              "Sigla usada nas corretoras",
              "BTC = Bitcoin, XLM = Stellar",
            ],
          ],
        },
      ],
    },
    {
      id: "mesmo-token",
      navLabel: "Mesmo Token",
      title: "🔄 Um mesmo token pode existir em várias redes",
      content: [
        {
          type: "paragraph",
          text: "Exemplo: USDC existe em:",
        },
        {
          type: "list",
          items: [
            "Ethereum",
            "Polygon",
            "Solana",
            "Stellar",
            "Avalanche",
            "Arbitrum",
            "Entre outras…",
          ],
        },
        {
          type: "paragraph",
          text: "🔥 Mas não são o mesmo token tecnicamente!",
        },
        {
          type: "paragraph",
          text: "Enviar USDC pela rede errada pode fazer o dinheiro sumir para sempre.",
        },
      ],
    },
    {
      id: "atencion",
      navLabel: "Atenção",
      title: "⚠️ O que acontece se você enviar por rede errada?",
      content: [
        {
          type: "list",
          items: [
            "Pode perder seus fundos permanentemente",
            "Nem corretoras nem carteiras conseguem reverter",
            "Não há botão de “cancelar”",
          ],
        },
        {
          type: "paragraph",
          text: "👉 Por isso, revise sempre:",
        },
        {
          type: "orderedList",
          items: [
            "Rede correta (ex.: Solana ≠ Ethereum)",
            "Endereço correto",
            "Token correto",
          ],
        },
        {
          type: "paragraph",
          text: "💬 Em Web3, você é o próprio banco.",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase do dia",
      title: "🧠 Frase do dia",
      content: [
        "Não se trata de qual blockchain é melhor, mas de qual resolve melhor um problema real.",
      ],
    },
  ],
};

export default modulo3_pt;
